import { MqttBroker } from '@frontend/pub-sub';
import { Transaction, TransactionActionName, TransactionStateName } from '@frontend/transaction/types';
import { useEffect, useRef } from 'react';

import { useAppSelector } from '../../redux/store';

interface UseTransactionListenerProps {
    id: string;
    onComplete?: (transaction: Transaction) => void;
    onCancelled?: (transaction: Transaction) => void;
    onFailed?: (transaction: Transaction) => void;
    onCompletedWithFailures?: (transaction: Transaction) => void;
    onProcessing?: (transaction: Transaction) => void;
}

export const useTransactionListener = (props: UseTransactionListenerProps) => {
    const navigationState = useAppSelector((store) => store.navigation);
    const IotId = navigationState.iot?.id;
    const propsRef = useRef(props);
    propsRef.current = props;

    useEffect(() => {
        if (!IotId) return;

        const callback = (message: string, data: any) => {
            const current = propsRef.current;
            const transaction = data.transaction as Transaction | undefined;
            if (!transaction) return;

            if (message === TransactionActionName.TRANSACTION_INFORM_IOT_PROCESSED && transaction.state === TransactionStateName.TRANSACTION_COMPLETED) {
                current.onComplete?.(transaction);
            }
            if (message === TransactionActionName.TRANSACTION_INFORM_IOT_CANCELLED && transaction.state === TransactionStateName.TRANSACTION_CANCELLED) {
                current.onCancelled?.(transaction);
            }
            if (message === TransactionActionName.TRANSACTION_INFORM_IOT_FAILED && transaction.state === TransactionStateName.TRANSACTION_FAILED) {
                current.onFailed?.(transaction);
            }
            if (
                message === TransactionActionName.TRANSACTION_INFORM_IOT_PROCESSED_WITH_FAILURES &&
                transaction.state === TransactionStateName.TRANSACTION_COMPLETED_WITH_FAILURES
            ) {
                current.onCompletedWithFailures?.(transaction);
            }
            if (message === TransactionActionName.TRANSACTION_INFORM_IOT_PROCESSING && transaction.state === TransactionStateName.TRANSACTION_PROCESSING) {
                current.onProcessing?.(transaction);
            }
        };

        MqttBroker.getInstance().subscribe(props.id + '_USE_TRANSACTION_LISTENER', 'iots/' + IotId + '/iot', callback);

        return () => {
            MqttBroker.getInstance().unSubscribe(props.id + '_USE_TRANSACTION_LISTENER', 'iots/' + IotId + '/iot');
        };
    }, [props.id, IotId]);
};
